import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginDataReflectService {

  subject = new Subject<any>();

  changeData(data: any) {
    this.subject.next(data);
  }

  sendData(): Observable<any> {
    return this.subject.asObservable();
  }
}
